export const de = {
  common: {
    learnMore: "Mehr erfahren",
    viewAll: "Alle ansehen",
    contactUs: "Kontakt aufnehmen",
    bookCall: "Erstgespräch buchen",
    seePricing: "Preise ansehen",
    requestProject: "Projekt anfragen",
    freeIntro: "Kostenloses Erstgespräch",
    askAi: "Ask AI",
    openAi: "Ask AI",
    openAiOverlayAria: "KI-Overlay öffnen",
    backHome: "Zurück zur Startseite",
    yes: "Ja",
    no: "Nein",
    loading: "Lade Preise.",
  },
  nav: {
    products: "Produkte",
    about: "Über uns",
    pricing: "Preise",
    contact: "Kontakt",
  },
  home: {
    hero: {
      title: "KI-Layer, Rework und Beratung für Ihre Website.",
      subtitle:
        "Wir bauen einen kontextbezogenen KI-Layer auf Ihrer bestehenden Seite, überarbeiten ganze Websites KI-nativ und begleiten Sie langfristig. Direkte Zusammenarbeit mit denen, die auch coden.",
    },
    products: {
      title: "Was wir machen.",
      lead: "Drei Kern-Angebote, gebaut für direkte, langfristige Zusammenarbeit. Sie reden mit denen, die auch coden. Keine Account-Manager-Schicht dazwischen.",
      moreHeading: "Mehr Projekte & Produkte",
      moreLink: "Alle Produkte ansehen",
      services: {
        overlay: {
          name: "AI Overlay",
          tagline: "KI-Layer auf Ihrer bestehenden Website.",
          desc: "Ein kontextbezogener AI-Layer, trainiert auf Ihren Inhalten, genau wie der auf dieser Seite. Beantwortet Fragen, generiert passende Interfaces live und führt Besucher zu Ihren Inhalten. Ohne Re-Launch, in 1 bis 2 Wochen integriert.",
          bullets: [
            "Ab €29/Monat bei 12 Monaten Laufzeit",
            "Setup gratis, wenn Sie es selbst machen",
            "Trainiert auf Ihren Inhalten",
          ],
        },
        rework: {
          name: "Website Rework, AI First",
          tagline: "Bestehende Seiten KI-nativ neu denken.",
          desc: "Wir re-designen Ihre Website mit KI als zentraler Interaktion, nicht als angeflanschtem Chatbot. Conversion-relevante Wege, generative Inhalte, klare Architektur. Festpreis, fixe Phasen, planbarer Launch.",
          bullets: [
            "Festpreis pro Phase",
            "Design und Engineering aus einer Hand",
            "Live-Prototyp nach 1 bis 2 Wochen",
          ],
        },
        longterm: {
          name: "Langzeit-Betreuung",
          tagline: "Direkte, langfristige Zusammenarbeit.",
          desc: "Beratung, Wartung und Weiterentwicklung mit denselben Köpfen, die gebaut haben. Sie reden mit Devs, nicht mit Account-Managern. Monatliche Iterationen, klare Roadmap, planbarer Aufwand.",
          bullets: [
            "Direkter Draht zu Devs",
            "Monatliche Iteration",
            "Beratung inklusive",
          ],
        },
      },
      moreProducts: {
        cate: "Infinite Canvas IDE für Coding-Agenten",
        "one-click-deploy": "Container auf eigene Server deployen",
        sight: "SEO- und KI-Sichtbarkeits-Audits",
        skyline: "iOS-App zum Entdecken von Gebäuden",
        foody: "iOS-App für Vorrat und Rezepte",
      },
    },
    why: {
      title: "Das Web denkt sich gerade neu.",
      titleAccent: " Wir bauen daran mit.",
      lead: "Die nächste Generation von Web-Software wird nicht durch KI ergänzt, sie wird durch KI definiert. Daraus folgen drei Prinzipien, an denen wir alles messen, was wir bauen.",
      principles: [
        {
          n: "01",
          title: "KI als Interface",
          body: "Jede ernsthafte Web-Anwendung bekommt in den nächsten Jahren eine native KI-Schicht. Nicht als angeflanschter Chatbot, sondern als zentrale Interaktionsform.",
        },
        {
          n: "02",
          title: "Open Source als Default",
          body: "Was wir bauen, soll auch ohne uns funktionieren. Unsere Tools sind MIT-lizenziert. Kein Lock-in, keine Black-Box, kein Vendor-Hostage.",
        },
        {
          n: "03",
          title: "Produktion vor Pitch",
          body: "Wir bauen Software, die deployed wird, nicht Demos für die Folie. Stabile Stacks, transparente Kosten, planbarer Betrieb. Das wirklich Wichtige ist immer das Boring Stuff.",
        },
      ],
    },
    how: {
      title: "Vier Schritte.",
      titleAccent: " Keine Überraschungen.",
      lead: "Festpreise für klar abgegrenzte Phasen. Sie wissen vom ersten Tag, was es kostet und was Sie wann bekommen.",
      steps: [
        {
          n: "01",
          label: "Discovery",
          title: "Erstgespräch & Scope",
          body: "Kostenloses 60-Min-Gespräch. Wir klären Anwendungsfall, Datenlage, Budget und ob KI überhaupt der richtige Hebel ist.",
        },
        {
          n: "02",
          label: "Prototyp",
          title: "1 bis 2 Wochen, fixer Preis",
          body: "Funktionierender Prototyp mit echtem Stack. Sie sehen früh, wie es sich anfühlt, bevor das volle Budget liegt.",
        },
        {
          n: "03",
          label: "Build",
          title: "Engineering & Design",
          body: "Inkrementelle Auslieferung in 2-Wochen-Iterationen. Frontend, Backend, KI-Layer und Infrastruktur aus einer Hand.",
        },
        {
          n: "04",
          label: "Operate",
          title: "Wartung & Weiterentwicklung",
          body: "Optionaler Wartungsvertrag. Wir betreiben mit, halten Modelle aktuell und entwickeln auf Roadmap weiter.",
        },
      ],
    },
    who: {
      title: "0-AI UG. Kleines Studio, klare Haltung.",
      lead: "Wir sind ein Studio für KI-native Web-Software aus Deutschland. Klein, fokussiert, mit eigenen Produkten als Basis. Sie arbeiten direkt mit denen, die auch coden.",
      stats: [
        { n: "5+", label: "Eigene Produkte" },
        { n: "10+", label: "Jahre Web-Engineering" },
        { n: "100%", label: "Open-Source-Anteil, wo möglich" },
      ],
      links: {
        about: "Über uns",
        opensource: "Open Source",
        work: "Case Studies",
      },
    },
    pricing: {
      title: "Drei Pakete. Festpreis.",
      lead: "Wartungsvertrag und KI-Layer optional kombinierbar. Endpreise inkl. Rabatten und Beispielen auf der Preisseite.",
      popular: "Beliebt",
      onRequest: "Auf Anfrage",
      onRequestNote: "individuelles Angebot",
      from: "ab €",
      onceTax: "einmalig, zzgl. MwSt.",
      details: "Alle Details",
      fullPricing: "Vollständige Preisübersicht",
    },
    cta: {
      title: "Reden wir über Ihr Projekt.",
      lead: "Kostenloses 60-Minuten-Erstgespräch. Wir klären gemeinsam, ob und wie KI für Ihr Vorhaben sinnvoll ist. Unverbindlich, ohne Sales-Pitch.",
      bookConsulting: "Beratung buchen",
    },
    cate: {
      eyebrow: "Unser Produkt",
      title: "CATE. Die IDE als unendlicher Canvas.",
      lead: "Parallele Coding-Agenten auf einem zoombaren Canvas. Jedes Terminal zeigt, ob sein Agent arbeitet, fertig ist oder wartet. Open Source, MIT-lizenziert.",
      bullets: [
        "Agenten-Chat mit Codex, Claude Code, Cursor und mehr",
        "Agent-fähige Terminals mit Status und Benachrichtigungen",
        "Git-Worktrees mit einem Klick",
        "Integrierter Browser und die cate CLI",
      ],
      cta: "Mehr zu CATE",
      github: "GitHub",
    },
    aiPeek: {
      title: "Oder lassen Sie unsere KI antworten.",
      lead: "Wir haben dieser Seite einen kontextbezogenen KI-Layer mitgegeben, genau wie wir ihn auch für Sie bauen. Stellen Sie eine Frage, und unten öffnet sich live ein passendes Interface.",
      hint: "↓ scrollen, um den Layer in Aktion zu sehen",
    },
  },
  footer: {
    impressum: "Impressum",
    datenschutz: "Datenschutz",
    rights: "Alle Rechte vorbehalten",
  },
  about: {
    title: "Über uns",
    subtitle:
      "Wir sind 0-AI, ein kleines Studio aus Stuttgart, das KI-gestützte Software mit Sorgfalt, Geschwindigkeit und Transparenz entwickelt.",
    stats: [
      { v: "2026", k: "Gegründet in Stuttgart" },
      { v: "1 bis 2 Wo.", k: "Bis zum ersten Prototyp" },
      { v: "100%", k: "Eigene Devs, keine Subcontractor" },
    ],
    foundersEyebrow: "Gründer",
    foundersTitle: "Zwei Brüder, ein Studio",
    foundersBody:
      "0-AI wurde von Paul und Anton Horn gegründet, mit dem Anspruch, KI nicht als Feature, sondern als zentrale Interaktionsschicht zu bauen. Wir kombinieren Design-Denken mit tiefem Engineering und arbeiten direkt mit unseren Kunden, ohne Account Manager dazwischen.",
    paul: {
      role: "CEO / Design & Frontend",
      name: "Paul Horn",
      body: "Studierte Online-Medienmanagement mit Schwerpunkt Design, User Experience, Kommunikation, Frontend und Ideation. Verantwortet Konzept, Design-System und die KI-native UI-Schicht. Davor mehrere Jahre Produkt- und Agenturarbeit.",
    },
    anton: {
      role: "CTO / Engineering",
      name: "Anton Horn",
      body: "Studierte Medieninformatik. Verantwortet Architektur, Backend, Infrastruktur und die Anbindung der LLM-Schicht. Tief in Bun, TypeScript und selbst gehosteten Deploys. Alles, was wir bauen, läuft auf Stacks, die man auch ohne uns weiter betreiben kann.",
    },
    coreBlocks: [
      {
        h: "Wer wir sind",
        b: "0-AI ist der Produkt- und Beratungsbereich der 0-AI UG (haftungsbeschränkt) mit Sitz in Stuttgart. Wir sind ein kleines Team aus Ingenieuren und Designern, das überzeugt ist: KI verändert grundlegend, wie Menschen mit Software interagieren, und die meisten Unternehmen kommen mit dieser Entwicklung nicht schnell genug mit.",
      },
      {
        h: "Was wir glauben",
        b: "KI sollte sich nicht wie ein nachträglich eingebautes Feature anfühlen. Sie sollte das gesamte Erlebnis neu gestalten, von der Art, wie Nutzer Funktionen entdecken, bis hin zur Art, wie sie ihre Ziele erreichen. Wir gestalten und bauen für diese Zukunft.",
      },
      {
        h: "Wie wir arbeiten",
        b: "Wir liefern in Wochen, nicht in Quartalen. Wir entwickeln offen. Wir nutzen die besten verfügbaren Werkzeuge wie Bun, React, TypeScript, Claude, und scheuen uns nicht, Code wegzuwerfen, der dem Nutzer nicht dient. Jedes Projekt beginnt damit, das Problem zu verstehen, nicht die Technologie.",
      },
      {
        h: "Was uns von Agenturen unterscheidet",
        b: "Wir verkaufen keine Slides, keine Personentage und keinen austauschbaren Stack. Sie sprechen direkt mit denen, die auch coden. Was wir bauen, gehört Ihnen: Repository, Hosting, Daten. Auch wenn Sie uns morgen rauswerfen würden.",
      },
    ],
    principlesEyebrow: "Prinzipien",
    principlesTitle: "Wonach wir arbeiten",
    principles: [
      { n: "01", title: "Wochen, nicht Quartale", body: "Wir liefern in kurzen Zyklen. Erster nutzbarer Prototyp meist in 1 bis 2 Wochen, mit echtem Stack, echten Inhalten, echter KI." },
      { n: "02", title: "Dieselben Köpfe konzipieren und bauen", body: "Kein Übergabe-Ping-Pong zwischen Agentur, Designer und Dev-Studio. Die Person, die das Konzept zeichnet, schreibt auch den Code." },
      { n: "03", title: "Code, der weggeworfen werden darf", body: "Wir halten an nichts fest, das dem Nutzer nicht dient. Refactor ist normal, nicht Notfall." },
      { n: "04", title: "Open by default", body: "Unser Stack ist offen. Unsere Tools sind Open Source. Sie bekommen Schlüssel, Repos, alles. Keine Vendor-Lock-Ins." },
    ],
    productsEyebrow: "Eigene Produkte",
    productsTitle: "Womit wir arbeiten und was wir selbst bauen",
    productsLead:
      "Wir bauen die Werkzeuge, die wir täglich nutzen, und dazu Apps und Dienste für alle. Von einer IDE für Coding-Agenten und einer Deployment-Plattform bis zu einem SEO-Audit-Dienst und zwei iOS-Apps.",
    products: [
      { slug: "cate", name: "CATE", desc: "Infinite-Canvas-IDE für Coding-Agenten." },
      { slug: "one-click-deploy", name: "Open CLI Deployment", desc: "Open-Source-Alternative zu Heroku und Railway." },
      { slug: "sight", name: "Sight", desc: "SEO- und KI-Sichtbarkeits-Audits für Ihre Website." },
      { slug: "skyline", name: "Skyline Spotter", desc: "iOS-App zum Entdecken und Sammeln von Gebäuden." },
      { slug: "foody", name: "Foody", desc: "iOS-App für Vorrat, Einkaufsliste und Rezepte." },
    ],
    githubCard: {
      title: "Alles auf GitHub",
      body: "Unsere Repositories sind öffentlich. Lesen Sie den Code, forken Sie ihn, schreiben Sie Issues. Auch unsere internen Tools entstehen offen.",
    },
    stackEyebrow: "Stack",
    stackTitle: "Womit wir bauen",
    stackLead:
      "Schlanker Stack, der schnell startet, sich gut anfühlt und sich überall hosten lässt. Keine Frameworks, die uns 18 Monate später wieder loswerden müssen.",
    stack: [
      { label: "Bun", note: "Runtime & Bundler" },
      { label: "React 19", note: "UI" },
      { label: "TypeScript", note: "Strict, end-to-end" },
      { label: "Tailwind v4", note: "Design System" },
      { label: "Claude / OpenRouter", note: "LLM-Layer" },
      { label: "MCP", note: "Tool-Use & Agenten" },
      { label: "Hetzner / Docker", note: "Self-hosted Deploys" },
      { label: "SQLite / Postgres", note: "Daten" },
    ],
    servicesEyebrow: "Leistungen",
    servicesTitle: "Was wir anbieten",
    services: [
      { label: "Consulting", href: "/consulting", desc: "KI-Strategie, Architekturreviews und technische Beratung für Teams, die mit LLMs entwickeln." },
      { label: "Design & Build", href: "/design", desc: "KI-natives UI/UX-Design und Full-Stack-Entwicklung vom Konzept bis zur Produktion." },
    ],
    ctaTitle: "Sie haben eine Idee, oder eine Website, die sich neu anfühlen sollte?",
    ctaLead: "Erstgespräch ist kostenlos. Wir sagen ehrlich, ob wir die richtigen sind.",
  },
  contact: {
    title: "Kontakt",
    subtitle: "Sprechen wir über Ihr Projekt. Wir antworten innerhalb von 24 Stunden.",
    writeUsHeading: "Schreiben Sie uns",
    writeUsBody:
      "Ob Sie KI zum ersten Mal erkunden oder ein bestehendes System skalieren möchten, wir freuen uns von Ihnen zu hören. Wir arbeiten mit Unternehmen aller Größen, von Startups, die ihr erstes KI-Feature ausliefern, bis hin zu Konzernen, die Legacy-Systeme modernisieren.",
    channelsHeading: "Kontaktmöglichkeiten",
    email: "E-Mail",
    github: "GitHub",
    location: "Standort",
    locationValue: "Stuttgart, Deutschland. Remote-first",
    foundersHeading: "Ihre Ansprechpartner",
    founders: [
      {
        name: "Paul Horn",
        role: "CEO / Design & Frontend",
        bio: "Studierte Online-Medienmanagement mit Schwerpunkt UX, Kommunikation und Ideation. Verantwortet Konzept, Design-System, Projektsteuerung und die KI-native UI-Schicht.",
        image: "/assets/team/anton-horn.png",
        email: "paul@cero-ai.com",
        linkedin: "https://www.linkedin.com/in/paulwphorn/",
      },
      {
        name: "Anton Horn",
        role: "CTO / Engineering",
        bio: "Studierte Medieninformatik. Verantwortet Architektur, KI-Integration, Backend und Infrastruktur. Tief in Bun, TypeScript, LLM-Stacks und selbst gehosteten Deploys.",
        image: "/assets/team/paul-horn.png",
        email: "anton@cero-ai.com",
        linkedin: "https://www.linkedin.com/in/anton-horn/",
      },
    ],
    expectHeading: "Was Sie erwartet",
    steps: [
      { step: "01", label: "Erstgespräch", desc: "60 Minuten. Wir lernen Ihr Projekt, Ihre Ziele und Rahmenbedingungen kennen." },
      { step: "02", label: "Angebot", desc: "Innerhalb von 48 Stunden. Umfang, Zeitplan und Preis zugeschnitten auf Ihre Bedürfnisse." },
      { step: "03", label: "Kickoff", desc: "Wir fangen an zu entwickeln. Sie sehen Fortschritte in Tagen, nicht Wochen." },
    ],
  },
  pricing: {
    title: "Preise",
    subtitle:
      "Drei Pakete für jede Größe. Wartungsvertrag und KI-Layer optional kombinierbar. Preise einmalig, zzgl. MwSt.",
    wartungLabel: "Wartung",
    wartungOhne: "Ohne",
    kiLabel: "KI-Layer",
    wartungEyebrow: "Wartungsvertrag",
    wartungLead:
      "Laufzeit 12 Monate. Der Festpreis Ihrer Webseite reduziert sich entsprechend. Die Differenz finanziert die laufende Pflege.",
    filterOhneEyebrow: "Ohne Wartung",
    filterOhneTitle: "Nur Webseite",
    filterOhneDesc: "Festpreis ohne Abo.",
    selected: "✓ ausgewählt",
    select: "Auswählen →",
    popular: "Beliebt",
    recommended: "Empfohlen",
    onRequest: "Auf Anfrage",
    onRequestNote: "individuelles Angebot",
    onceTax: "einmalig, zzgl. MwSt.",
    maintenance: "+ €{{price}}/Mo Wartung",
    kiAdd: "+ €{{price}}/Mo AI-Layer ({{plan}})",
    bookCall: "Gespräch vereinbaren",
    requestProject: "Projekt anfragen",
    kiSectionTitle: "AI-Layer auf Ihrer Website.",
    kiSectionLead:
      "Kontextbezogener AI-Layer, trainiert auf Ihren Inhalten. Basic mit 1.000 Antworten im Monat oder Pro mit 4.000, oder Abrechnung pro Antwort. Preise inkl. MwSt.",
    kiMonthSuffix: "/Monat bei 12 Monaten Laufzeit",
    kiActive: "✓ aktiv",
    kiAddBtn: "Hinzufügen →",
    footerNote:
      "Website-Preise zzgl. MwSt., KI-Layer-Preise inkl. MwSt. Wartungsverträge mit 12 Monaten Mindestlaufzeit. Der KI-Layer läuft auf 1, 6 oder 12 Monate oder nutzungsbasiert für €0,02 pro Antwort. Setup gratis in Eigenregie, €99 gemeinsam, €249 komplett durch uns. Sie sind sich unsicher, welches Paket passt?",
    footerNoteLink: "Sprechen Sie uns an.",
  },
  products: {
    title: "Produkte & Angebote",
    subtitle:
      "Drei Kern-Angebote für Ihre Website, plus die Open-Source-Tools und Produkte, die wir parallel entwickeln und betreiben.",
    coreHeading: "Kern-Angebote",
    coreLead: "Was wir für Ihre Website tun. Direkte Zusammenarbeit mit denen, die auch coden.",
    ownHeading: "Eigene Produkte",
    ownLead:
      "Open-Source-Tools und Plattformen, die wir parallel entwickeln. Sie bilden die Basis für die Arbeit an Kundenprojekten.",
    status: {
      openSource: "Open Source",
      beta: "Beta",
      inDev: "In Entwicklung",
      webApp: "Web-App",
      ios: "iOS-App",
    },
    list: [
      {
        slug: "cate",
        name: "CATE",
        tagline: "Infinite Canvas IDE für Coding-Agenten",
        description: "Open-Source-IDE auf einem zoombaren Canvas für parallele Coding-Agenten. Agent-fähige Terminals, Git-Worktrees, Editor- und Browser-Panels.",
        status: "openSource",
      },
      {
        slug: "one-click-deploy",
        name: "Open CLI Deployment",
        tagline: "Container auf eigene Server deployen.",
        description: "Selbst gehostete, CLI-first Plattform, die Images aus Git baut und auf Ihre eigenen Server deployt, mit TLS, Rollbacks und Scaling. Die Alternative zu Heroku, Railway und Render.",
        status: "openSource",
      },
      {
        slug: "sight",
        name: "Sight",
        tagline: "SEO- und KI-Sichtbarkeits-Audits",
        description: "Einmal scannen und sehen, wie Ihre Website bei Google und in KI-Antworten abschneidet: wo ChatGPT, Gemini, Claude und Perplexity Sie nennen, was Sie ausbremst und was zuerst zu tun ist.",
        status: "webApp",
      },
      {
        slug: "skyline",
        name: "Skyline Spotter",
        tagline: "Look up and explore.",
        description: "iOS-App, um die Gebäude in Ihrer Umgebung zu entdecken. Städte durchstöbern, Sichtungen mit eigenen Fotos sammeln und fehlende Gebäude oder Fakten vorschlagen.",
        status: "ios",
      },
      {
        slug: "foody",
        name: "Foody",
        tagline: "Mehr aus dem machen, was da ist.",
        description: "iOS-App, die Ihre Vorräte kennt, die Einkaufsliste aktuell hält und Rezepte findet, die wirklich passen. Ein gemeinsamer Stand für den ganzen Haushalt.",
        status: "ios",
      },
    ],
  },
  productPage: {
    websiteLinkAria: "Website öffnen",
    galleryLabel: "Screenshots",
    downloadTitle: "Jetzt herunterladen.",
    downloadLead: "Verfügbar für macOS, Windows und Linux. Open Source, MIT-lizenziert.",
    downloadBtn: "Download",
  },
  productDetails: {
    "ai-overlay": {
      title: "AI Overlay",
      subtitle: "Ein kontextbezogener KI-Layer auf Ihrer bestehenden Website, trainiert auf Ihren Inhalten. Beantwortet Fragen, generiert passende Interfaces live, führt Besucher zu Ihren Inhalten. Ohne Re-Launch.",
      sections: [
        { heading: "Was ist der AI Overlay?", body: "Ein leichtgewichtiger Layer, der über Ihrer bestehenden Website liegt. Besucher stellen eine Frage in natürlicher Sprache. Der Layer antwortet kontextbezogen auf Basis Ihrer Inhalte und blendet live ein passendes Interface ein, zum Beispiel Karten, Tabellen, Formulare, Vergleiche. Genau wie der Layer auf dieser Seite." },
        { heading: "Kein Re-Launch nötig", body: "Der Overlay wird per Script-Tag eingebunden, vergleichbar mit einem Analytics-Snippet. Ihre bestehende Seite bleibt unangetastet. Inhalte, Routing, CMS, SEO bleiben unverändert. Integration in 1 bis 2 Wochen, inkl. erstem Trainings-Crawl." },
        { heading: "Trainiert auf Ihren Inhalten", body: "Wir indexieren Ihre Website, Dokumente und optional weitere Quellen wie Notion, Confluence, Helpdesk, PDFs. Antworten sind grounded, mit Quellenangaben statt Halluzinationen. Inhalte werden bei Änderungen re-indexiert, manuell oder via Webhook." },
        { heading: "Generative Interfaces", body: "Statt nur Text liefert der Layer live gerenderte Komponenten wie Kontaktkarten, Projektgalerien, Preisvergleiche, FAQ-Listen, Formulare. Die Auswahl passiert kontextbezogen. Der Layer entscheidet pro Frage, welches Interface am besten passt." },
        { heading: "Preise & Betrieb", body: "Basic (1.000 Antworten im Monat) kostet €49/Monat monatlich kündbar, €39 bei 6 Monaten und €29 bei 12 Monaten Laufzeit. Pro (4.000 Antworten) kostet €129, €99 und €79. Lieber ohne Grundgebühr? Nutzungsbasiert zahlen Sie €0,02 pro Antwort. Zusatzpakete mit 1.000 Antworten kosten €20. Setup ist gratis in Eigenregie, €99 gemeinsam und €249, wenn wir es komplett übernehmen. Optionale Betreuung ab €29/Monat. Alle Preise inkl. MwSt." },
        { heading: "Für wen sinnvoll?", body: "Unternehmen mit erklärungsbedürftigen Produkten, umfangreicher Dokumentation, vielen Support-Anfragen oder komplexen Sortimenten. Wenig sinnvoll auf reinen One-Pagern oder Shops mit Standard-Suche." },
      ],
    },
    "website-rework": {
      title: "Website Rework, AI First",
      subtitle: "Wir re-designen Ihre Website mit KI als zentraler Interaktion, nicht als angeflanschtem Chatbot. Conversion-relevante Wege, generative Inhalte, klare Architektur. Festpreis, fixe Phasen.",
      sections: [
        { heading: "Was heißt AI First?", body: "KI ist nicht ein Widget in der Ecke, sondern Teil der Hauptinteraktion. Navigation, Suche, Erklärung, Konfiguration, Beratung. Alles kann konversational oder generativ werden, wo es Sinn ergibt. Die klassische Seitenstruktur bleibt für SEO und Direkt-Einstieg erhalten." },
        { heading: "Was Sie bekommen", body: "Neue Informationsarchitektur, Design-System, KI-native Komponenten, Engineering inkl. Hosting-Setup. Frontend in React/TypeScript, Backend in Bun/Node, KI über Anthropic/OpenAI/OpenRouter. Auf Wunsch komplett Open-Source-Stack." },
        { heading: "Phasen & Festpreis", body: "Phase 1: Discovery & Konzept (Festpreis, 1 bis 2 Wochen). Phase 2: Prototyp mit echtem Stack (Festpreis, 1 bis 2 Wochen). Phase 3: Vollausbau in 2-Wochen-Iterationen. Sie wissen vor jeder Phase, was es kostet und was Sie bekommen." },
        { heading: "Live-Prototyp nach 1 bis 2 Wochen", body: "Bevor das volle Budget liegt, sehen Sie einen funktionierenden Prototyp mit echten Inhalten und echter KI. Kein Mock-Up, keine Folien. Sie klicken sich durch und entscheiden, ob die Richtung stimmt." },
        { heading: "Design und Engineering aus einer Hand", body: "Keine Übergaben zwischen Agentur, Designer und Dev-Studio. Dieselben Köpfe konzipieren, gestalten und bauen. Das spart Zeit, vermeidet Reibungsverluste und führt zu Lösungen, die in der Implementierung auch wirklich funktionieren." },
        { heading: "Langfristig betreut", body: "Auf Wunsch übernehmen wir Wartung, Weiterentwicklung und Betrieb mit denselben Devs, die gebaut haben. Monatliche Iteration, klare Roadmap, planbarer Aufwand. Details auf der Beratungs-Seite." },
      ],
    },
    cate: {
      title: "CATE",
      subtitle: "Eine Open-Source-IDE als unendlicher Canvas für parallele Coding-Agenten. Terminals, Editoren und Browser schweben auf einer zoombaren Fläche, und jedes Terminal zeigt, ob sein Agent arbeitet, fertig ist oder wartet.",
      tagline: "Ein unendlicher Canvas für alle Ihre Coding-Agenten.",
      highlights: [
        "Agenten-Chat mit Codex, Claude Code, Cursor, Grok und mehr",
        "Agent-fähige Terminals mit Status und Benachrichtigungen",
        "Git-Worktrees mit einem Klick, ein Bereich pro Branch",
        "Monaco Editor und xterm.js-Terminals mit WebGL",
        "Integrierter Browser und die cate CLI für Agenten",
        "Lokale und entfernte Runtimes über Ende-zu-Ende-verschlüsseltes Cate Connect",
        "Verfügbar für macOS, Windows und Linux",
        "Open Source unter MIT-Lizenz",
      ],
      sections: [
        { heading: "Was ist CATE?", body: "CATE denkt die IDE als unendlichen Canvas für die Arbeit mit parallelen Coding-Agenten neu. Statt Tabs und geteilter Ansichten ordnen Sie Terminals, Editoren und Browser-Vorschauen räumlich an, wie Figma, aber für Code. Ein Workspace ist einfach ein geöffneter Ordner, ganz ohne Konfigurationsdateien." },
        { heading: "Für wen gebaut?", body: "Für Entwickler, die mehrere Coding-Agenten gleichzeitig laufen lassen und sehen müssen, welche arbeiten, fertig sind oder auf eine Eingabe warten. Wer regelmäßig zwischen Agenten, Terminals, Editoren, Logs und Vorschauen wechselt, gewinnt mit CATE eine räumliche Ordnung, die Tab-basierte IDEs nicht bieten." },
        { heading: "Agenten im Mittelpunkt", body: "Ein Agenten-Chat integriert Codex, Claude Code, Cursor, Grok, OpenCode und mehr. Agent-fähige Terminals melden die Zustände läuft, wartet und fertig, senden Benachrichtigungen und setzen Sessions nach einem Neustart samt Scrollback fort. Agenten in einem Cate-Terminal können über die cate CLI den integrierten Browser steuern, andere Terminals lesen und Dateien öffnen." },
        { heading: "Worktrees & räumliches Arbeiten", body: "Erstellen Sie mit einem Klick einen Git-Worktree samt Branch aus einem lokalen Branch, einem Remote-Branch oder einem Pull Request. Jeder Worktree bekommt einen eigenen farbigen Bereich auf dem Canvas. Panels lassen sich frei platzieren, in Tabs und Splits andocken oder in ein eigenes Fenster lösen, und das Layout bleibt pro Projekt erhalten." },
        { heading: "Editor, Git & Remote", body: "Monaco Editor, xterm.js-Terminals mit WebGL, Multi-Repo-Versionskontrolle mit Side-by-Side-Diffs, ripgrep-Suche, Cmd+K Command Palette, anpassbare Shortcuts und datengetriebene Themes. Workspaces laufen in lokalen oder entfernten Runtimes und laufen weiter, wenn das Fenster geschlossen wird. Geräte koppeln Sie per QR-Code über eine Ende-zu-Ende-verschlüsselte Cate-Connect-Verbindung." },
        { heading: "Tech Stack & Open Source", body: "Electron 41, React 18, TypeScript, Tailwind CSS, Zustand, Monaco Editor und xterm.js mit node-pty. MIT-lizenziert und kostenlos auf GitHub, mit Builds für macOS (auch via Homebrew), Windows und Linux." },
      ],
    },
    "one-click-deploy": {
      title: "Open CLI Deployment",
      subtitle: "Eine selbst gehostete, CLI-first Plattform, um Container auf eigene Server zu deployen. Die Open-Source-Alternative zu Heroku, Railway und Render.",
      sections: [
        { heading: "Was ist Open CLI Deployment?", body: "Eine CLI-first Plattform, die unveränderliche OCI-Images aus Git baut und auf Ihren eigenen Linux-Servern ausrollt. Sie arbeiten über die ocd CLI; ein kleines selbst gehostetes Panel hält Soll-Zustand, Zugangsdaten, Verlauf und Recovery. Geführtes Setup mit ocd bootstrap, optionale Provisionierung von Hetzner-Servern und -Volumes." },
        { heading: "Kernfunktionen", body: "Deployments aus jedem Git-Repository über .ocd-deploy.json-Manifeste, auch für Multi-Service-Stacks mit abgeleiteter Startreihenfolge. Digest-gepinnte, unveränderliche Releases mit Promote und Rollback. Logs, Shell, Dateikopie, Pause und Scaling direkt aus der CLI. Incident- und Recovery-Abläufe, Benachrichtigungen und ein installierbarer Agent-Skill." },
        { heading: "Sicherheit & Betrieb", body: "Traefik übernimmt das Ingress mit automatischem TLS. Das Panel ist per Passkeys (WebAuthn) geschützt. Builds laufen auf BuildKit-Workern, dahinter arbeiten Postgres und S3-kompatibler Speicher. GitHub Webhooks können Builds auslösen." },
        { heading: "Open Source", body: "Vollständig Open Source unter MIT-Lizenz. Gebaut mit Bun, TypeScript und React 19. Die CLI läuft auf macOS und Linux (x64 und arm64), das Panel auf jedem Linux-Docker-Host. Verfügbar auf GitHub." },
      ],
    },
  },
  services: {
    consulting: {
      title: "Consulting",
      subtitle: "KI-Strategie, Architektur-Reviews und technische Beratung für Teams, die mit LLMs und moderner KI-Infrastruktur entwickeln.",
      sections: [
        { heading: "Was wir tun", body: "Wir helfen Unternehmen, sich im KI-Umfeld zu orientieren. Von der Bewertung geeigneter Modelle bis hin zum Entwurf skalierbarer Produktionsarchitekturen. Wir haben KI-gestützte Produkte in verschiedenen Branchen ausgeliefert und bringen diese Erfahrung in Ihr Team." },
        { heading: "Strategie & Roadmapping", body: "KI-Adoption ist mehr als die Wahl eines Modells. Wir helfen Ihnen, wirkungsvolle Potenziale zu identifizieren, Build-vs-Buy-Entscheidungen zu bewerten und pragmatische Roadmaps zu erstellen, die in Wochen liefern, nicht in Quartalen." },
        { heading: "Architektur-Reviews", body: "Bereits in der Entwicklung? Wir überprüfen Ihren KI-Stack, also RAG-Pipelines, Agenten-Architekturen, Prompt Engineering, Modellauswahl, Kostenoptimierung, und zeigen auf, wo Performance oder Zuverlässigkeit Potenzial lassen." },
        { heading: "Team Enablement", body: "Wir arbeiten direkt mit Ihren Entwicklern zusammen und transferieren Wissen während des Aufbaus. Das Ziel ist stets, Ihr Team leistungsfähiger zu machen, nicht Abhängigkeit zu erzeugen." },
      ],
    },
    design: {
      title: "Design",
      subtitle: "UI/UX für KI-native Produkte. Wir gestalten Interfaces, bei denen KI natürlich wirkt, nicht aufgesetzt.",
      sections: [
        { heading: "KI-natives Design", body: "KI-Interfaces sind mehr als Chatbots. Wir gestalten Erlebnisse, bei denen KI jede Interaktion bereichert, von intelligenten Standardwerten über kontextuelle Vorschläge bis zu generativen Inhalten, alles als natürlicher Teil des Produkts." },
        { heading: "Vom Konzept zum System", body: "Wir beginnen mit Nutzerforschung und schnellen Prototypen, entwickeln dann vollständige Design-Systeme mit Komponentenbibliotheken, Interaktionsmustern und Dokumentation, die Ihr Team erweitern kann." },
        { heading: "Was wir gestaltet haben", body: "Räumliche IDEs, konversationale Widgets, narrative Plattformen, Design-Editoren, Trading-Dashboards. Jedes Projekt erweitert die Grenzen dessen, wie KI-Interfaces sich anfühlen können." },
        { heading: "Tools & Vorgehen", body: "Figma für Design, React für Prototypen, Tailwind für Systeme. Wir iterieren schnell. Sie sehen funktionierende Interfaces in Tagen, nicht Wochen. Jede Designentscheidung basiert auf realen technischen Rahmenbedingungen." },
      ],
    },
    engineering: {
      title: "Engineering",
      subtitle: "Full-Stack-KI-Entwicklung. Vom Prototypen zur Produktion in Wochen, nicht Quartalen.",
      sections: [
        { heading: "Wie wir entwickeln", body: "Wir liefern schnell, ohne Abstriche bei der Qualität. Unser Stack mit Bun, React, TypeScript, Claude/Anthropic SDK ist auf Geschwindigkeit und Zuverlässigkeit ausgelegt. Wir setzen auf moderne Tools, weil sie uns schneller vorankommen und bessere Ergebnisse erzielen lassen." },
        { heading: "KI-Integration", body: "RAG-Pipelines, Agenten-Architekturen, Tool-Calling-Systeme, Streaming-UIs, MCP-Server. Wir haben KI-Produktionssysteme gebaut, die echten Traffic und echte Nutzer verarbeiten. Wir kennen die Fallstricke." },
        { heading: "Full Stack", body: "Frontend (React, Next.js, Tailwind), Backend (Bun, Node.js, Go, Python), Datenbanken (MongoDB, Qdrant, SQLite, Redis), Infrastruktur (Docker, Terraform, Hetzner, Vercel). Wir verantworten den gesamten Stack, damit nichts zwischen die Stühle fällt." },
        { heading: "Open Source zuerst", body: "Wir entwickeln wo immer möglich in der Öffentlichkeit. Unsere Tools, Bibliotheken und Muster sind MIT/CC-lizenziert. Zum Ökosystem beizutragen ist kein Nebenprojekt, es ist unsere Arbeitsweise." },
      ],
    },
  },
  offering: {
    forWhomLabel: "Für wen das passt",
    notForLabel: "Und für wen nicht",
    deliverablesTitle: "Was Sie konkret bekommen.",
    deliverablesLead: "Lieferumfang, der eindeutig abgegrenzt ist. Keine Schwammigkeit, keine vagen Versprechen.",
    processTitle: "So läuft die Zusammenarbeit.",
    processLead: "Klare Phasen, klare Meilensteine. Sie wissen am ersten Tag, was wann passiert.",
    pricingTitle: "Was es kostet.",
    faqTitle: "Häufige Fragen.",
    ctaTitle: "Reden wir konkret über Ihr Vorhaben.",
    ctaLead:
      "Kostenloses 60-Minuten-Erstgespräch. Wir klären in einer Stunde, ob {{offering}} der richtige Hebel ist und was ein realistischer nächster Schritt wäre.",
    bookCall: "Erstgespräch buchen",
    fullPricing: "Vollständige Preise",
    relatedLabel: "Verwandt",
    "ai-overlay": {
      title: "AI Overlay",
      subtitle:
        "Ein kontextbezogener KI-Layer auf Ihrer bestehenden Website, trainiert auf Ihren Inhalten, ohne Re-Launch, in 1 bis 2 Wochen integriert.",
      intro:
        "Ihre Website bleibt, wie sie ist. Wir setzen einen schmalen KI-Layer darüber, der den Inhalt Ihrer Seite kennt, Fragen Ihrer Besucher in natürlicher Sprache beantwortet und passende Interfaces live generiert, also Produktvergleiche, Kontaktformulare, Rechner, Roadmaps. Das gleiche Pattern, das Sie auf dieser Seite selbst ausprobieren können.",
      forWhom: [
        "Sie haben eine Website, die funktioniert, aber Besucher finden Informationen nicht.",
        "Sie wollen KI testen, ohne einen Re-Launch zu riskieren.",
        "Sie haben Dokumentation, Produktdaten oder Wissensartikel, die kaum jemand liest.",
        "Sie wollen messen, wonach Ihre Besucher tatsächlich fragen.",
      ],
      notForWhom: [
        "Sie wollen einen einfachen FAQ-Bot ohne Anbindung an Ihre Inhalte.",
        "Sie brauchen unbegrenzt viele Antworten ohne Nutzungslimit.",
        "Sie suchen ein White-Label-SaaS. Wir bauen für Sie, nicht für viele.",
      ],
      deliverables: [
        { title: "Embed-Script & Overlay-UI", body: "Ein einzelnes <script>-Tag, das den Layer auf jeder Unterseite aktiviert. Der Overlay öffnet sich on demand, kein nerviger Chat-Bubble, der von Anfang an aufpoppt." },
        { title: "Wissens-Index", body: "Wir crawlen Ihre Website, normalisieren Inhalte und legen einen Vektor-Index an. Optional zusätzlich PDFs, Notion, Confluence oder eigene Quellen." },
        { title: "Generative Interfaces", body: "Statt nur Text zurückzugeben, rendert der Layer passende Komponenten live: Produktkarten, Kontaktformular, Preisrechner, Vergleichstabelle, Terminbuchung. Wir definieren die Komponenten gemeinsam mit Ihnen." },
        { title: "Analytics-Dashboard", body: "Was fragen Besucher wirklich? Welche Antworten landen in einer Conversion? Wir liefern ein einfaches Dashboard mit Top-Fragen, Lücken im Wissensstand und Conversion-Pfaden." },
        { title: "Modell-Auswahl & Routing", body: "Kleines Modell für triviale Anfragen, großes für komplexe. Wir routen automatisch und halten Token-Kosten unter Kontrolle. Modell-Anbieter (Anthropic, OpenAI, lokal) ist konfigurierbar." },
        { title: "Wartung optional", body: "Re-Index bei Content-Änderungen, Modell-Updates, Prompt-Tuning. Pauschal monatlich oder per Sprint. Kein Vendor-Lock-in. Sie können den Layer jederzeit selbst betreiben." },
      ],
      process: [
        { label: "Tag 1 bis 2", title: "Kickoff & Inhalts-Audit", body: "Wir sichten Ihre Inhalte, definieren die ersten drei generativen Komponenten und legen Erfolgs-Metriken fest." },
        { label: "Tag 3 bis 7", title: "Index & Prompt-Engineering", body: "Wir crawlen, indizieren, schreiben System-Prompts und bauen die Komponenten. Sie bekommen einen Live-Prototypen, den Sie selbst durchklicken." },
        { label: "Tag 8 bis 10", title: "Iteration mit echtem Content", body: "Wir gehen Antworten gemeinsam durch. Wo der Layer halluziniert, wo er zu vorsichtig ist, wo Quellen fehlen. Daraus folgt der finale Schliff." },
        { label: "Tag 11 bis 14", title: "Embed & Go-Live", body: "Script auf Ihrer Seite, Analytics scharf, Modell-Routing produktiv. Hand-Off-Doku, damit Ihr Team den Layer auch ohne uns betreiben kann." },
      ],
      faq: [
        { q: "Was kostet das laufend?", a: "Basic (1.000 Antworten im Monat) kostet €29 bis €49/Monat je nach Laufzeit, Pro (4.000 Antworten) €79 bis €129/Monat. Zusatzpakete mit 1.000 Antworten kosten €20. Preise inkl. MwSt. Ihr Tarif begrenzt die Nutzung, es gibt also keine Überraschungen auf der Rechnung." },
        { q: "Was passiert mit Nutzerdaten?", a: "Standardmäßig keine Speicherung von Anfragen über das Analytics-Minimum hinaus. Hosting in Deutschland möglich. DSGVO-konform, mit AVV." },
        { q: "Funktioniert das auf jeder Website?", a: "Ja. Das Embed ist Framework-agnostisch. Statische Seite, WordPress, Shopify, Webflow, Custom-React. Wir brauchen nur eine Stelle, an der ein Script eingebunden werden kann." },
        { q: "Was, wenn die KI etwas Falsches sagt?", a: "Wir antworten ausschließlich aus Ihren Quellen, mit Zitation und Link zur Original-Stelle. Wo Quellen fehlen, sagt der Layer das und bietet einen Kontakt-Pfad an. Hallucinations-Rate messen wir kontinuierlich." },
      ],
      pricing: {
        headline: "Ab €29/Monat",
        lines: [
          "Basic: 1.000 Antworten/Monat für €49 monatlich kündbar, €39 bei 6 Monaten, €29 bei 12 Monaten.",
          "Pro: 4.000 Antworten/Monat für €129, €99 oder €79. Nutzungsbasiert: €0,02 pro Antwort, ohne Grundgebühr.",
          "Setup gratis in Eigenregie, €99 gemeinsam, €249 komplett durch uns. Optionale Betreuung ab €29/Monat.",
        ],
        note: "Alle Preise inkl. MwSt. Zusatzpakete mit 1.000 Antworten kosten €20.",
      },
      related: [
        { label: "Website Rework, AI First", href: "/services/website-rework" },
        { label: "Langzeit-Betreuung", href: "/services/langzeit-betreuung" },
        { label: "KI auf dieser Seite ausprobieren", href: "#ai" },
      ],
    },
    "website-rework": {
      title: "Website Rework, AI First",
      subtitle:
        "Bestehende Seiten KI-nativ neu denken. Wir re-designen Ihre Website mit KI als zentraler Interaktion. Festpreis, fixe Phasen, planbarer Launch.",
      intro:
        "Ein Chatbot oben rechts ist kein KI-natives Produkt. Eine KI-First-Website denkt Conversion-Pfade neu: Was muss überhaupt noch eine Seite sein, was wird zu einem Gespräch, was wird live aus Daten generiert? Wir machen das mit Ihnen, nicht als Workshop-Theater, sondern als auslieferbares Re-Design mit klarer Architektur.",
      forWhom: [
        "Ihre aktuelle Site fühlt sich an wie 2018 und Sie wissen, dass das Problem strukturell ist.",
        "Sie haben komplexe Produkte, Konfiguratoren oder beratungsintensive Angebote.",
        "Ihr Team kann den neuen Stack selbst weiterführen, will aber nicht von Null anfangen.",
        "Sie suchen kein Marketing-Refresh, sondern eine echte Produkt-Entscheidung.",
      ],
      notForWhom: [
        "Sie wollen primär ein optisches Refresh. Dann ist eine reine Design-Agentur günstiger.",
        "Sie haben kein produktives Backend / keine Datenbasis, mit der KI etwas anfangen kann.",
        "Sie brauchen 50+ Templates auf einmal. Wir sind nicht der richtige Maßstab.",
      ],
      deliverables: [
        { title: "Architektur-Konzept", body: "Welche Seiten bleiben Seiten, welche werden zu Conversation-Flows, welche werden live aus Daten gerendert. Inklusive Sitemap, Routing-Plan und Datenfluss-Diagramm." },
        { title: "Design-System (Code-First)", body: "Komponenten, Typografie, Farben, Motion. Alles direkt als React + Tailwind. Kein Figma-Friedhof, der nie umgesetzt wird. Ein Design-System ist Code, mit dem Sie auch nach uns weiterbauen können." },
        { title: "Live-Prototyp nach 1 bis 2 Wochen", body: "Funktionierender, deploybarer Prototyp der wichtigsten Flows, mit echtem KI-Layer, echten Daten, echtem Routing. Damit Sie früh entscheiden können, ob die Richtung stimmt." },
        { title: "Conversion-relevante KI-Pfade", body: "Wir identifizieren 3 bis 5 Stellen, an denen KI nicht nur Spielerei ist, sondern Conversion treibt: Produktberatung, Konfigurator, Onboarding, Lead-Qualifizierung, Self-Service." },
        { title: "Generative Inhalte", body: "Wo es Sinn ergibt, generieren wir Inhalte live aus Quellen statt sie redaktionell zu pflegen: personalisierte Case-Studies, dynamische Preisrechner, Sprach-Varianten." },
        { title: "Deployment & Übergabe", body: "Wir deployen auf Ihrer Infrastruktur oder unserer, wenn gewünscht (Hetzner, Docker, optional eigenes One-Click-Deploy). Vollständige Doku, Tech-Übergabe an Ihr Team." },
      ],
      process: [
        { label: "Phase 1", title: "Discovery & Konzept (Woche 1 bis 2)", body: "Workshops mit Ihrem Team, technisches Audit, Architektur-Entwurf. Ergebnis: dokumentiertes Konzept, Festpreis für die folgenden Phasen, Go/No-Go-Entscheidung." },
        { label: "Phase 2", title: "Prototyp (Woche 3 bis 4)", body: "Deploybarer Prototyp der drei wichtigsten Flows. Ende Phase 2 ist klar, ob das Re-Design seine Versprechen einlöst, bevor das volle Budget liegt." },
        { label: "Phase 3", title: "Build (Woche 5 bis 10)", body: "Inkrementelle Auslieferung in 2-Wochen-Sprints. Frontend, Backend, KI-Layer, Inhalts-Migration, SEO-Erhalt. Sie können wöchentlich auf Staging mitlaufen." },
        { label: "Phase 4", title: "Launch & Stabilisierung (Woche 11 bis 12)", body: "Cut-over, Monitoring, Performance-Tuning, Bugfix-Sprint. Optional anschließend Langzeit-Betreuung." },
      ],
      faq: [
        { q: "Wie lange dauert das insgesamt?", a: "Typisch 10 bis 12 Wochen für mittelgroße Sites. Sehr komplexe Projekte länger. Das klären wir in Phase 1 vor dem Build-Commit." },
        { q: "Was passiert mit unserem SEO?", a: "301-Redirect-Map, strukturierte Daten, sauberes Server-Rendering. KI-Flows als zusätzliche Schicht, nicht als Ersatz für indexierbare Inhalte. SEO ist Pflicht, nicht Kür." },
        { q: "Können wir nach Phase 2 aussteigen?", a: "Ja. Die ersten zwei Phasen sind bewusst abgeschlossen lieferbar. Konzept und Prototyp sind nutzbare Ergebnisse, auch wenn Sie nicht weiterbauen." },
        { q: "Welche Tech-Stack-Optionen haben wir?", a: "Default: Bun + React + Tailwind + Anthropic SDK. Alternativ Next.js, Astro, oder Integration in bestehende Stacks (Rails, Django, Laravel). Entscheidung nach Phase 1." },
      ],
      pricing: {
        headline: "Festpreis pro Phase",
        lines: [
          "Phase 1 (Konzept): pauschaler Festpreis nach Erstgespräch.",
          "Phase 2 (Prototyp): Festpreis nach Konzept. Sie kennen die Zahl, bevor wir starten.",
          "Phase 3 + 4 (Build & Launch): Festpreis nach Prototyp, basierend auf konkretem Scope.",
        ],
        note: "Sie committen nur auf die jeweils nächste Phase. Keine Open-End-Verträge. Konkrete Beträge im Erstgespräch.",
      },
      related: [
        { label: "AI Overlay", href: "/services/ai-overlay" },
        { label: "Langzeit-Betreuung", href: "/services/langzeit-betreuung" },
        { label: "Preisübersicht", href: "/pricing" },
      ],
    },
    "langzeit-betreuung": {
      title: "Langzeit-Betreuung",
      subtitle:
        "Beratung, Wartung und Weiterentwicklung mit denselben Köpfen, die gebaut haben. Sie reden mit Devs, nicht mit Account-Managern.",
      intro:
        "Eine Website ist nicht fertig, wenn sie online ist. Sie fängt dort an. KI-Modelle verändern sich monatlich, Inhalte wachsen, Conversion-Hypothesen wollen getestet werden. Wir bleiben an Bord als kleines, eingespieltes Team mit direktem Draht, monatlich planbar, ohne Service-Layer dazwischen.",
      forWhom: [
        "Sie haben eine KI-gestützte Site (von uns oder anderswo) und wollen sie weiterentwickeln.",
        "Sie wollen nicht für jeden kleinen Schritt ein neues Angebot einholen müssen.",
        "Sie schätzen Kontinuität. Dieselben Devs, die Ihre Codebase kennen.",
        "Sie wollen monatliche Iterationen statt großer Re-Launches.",
      ],
      notForWhom: [
        "Sie brauchen 24/7-Incident-Response. Dafür empfehlen wir spezialisierte Anbieter.",
        "Sie suchen ein klassisches Wartungs-Paket mit reiner Bugfix-SLA.",
        "Sie wollen Stunden statt Outcomes kaufen. Wir arbeiten Sprint-basiert, nicht stundenweise.",
      ],
      deliverables: [
        { title: "Monatliches Sprint-Budget", body: "Fester Stundenrahmen pro Monat, planbar auf 6 bis 12 Monate. Unverbrauchte Stunden rollen einen Monat weiter. Keine Überraschungen auf der Rechnung." },
        { title: "Direkter Slack/Discord-Kanal", body: "Ein gemeinsamer Channel mit den Devs. Reaktion innerhalb von 4 Stunden während der Bürozeiten. Keine Tickets, keine First-Level-Schicht." },
        { title: "Roadmap-Pflege", body: "Wir pflegen mit Ihnen zusammen eine sichtbare Roadmap: Quartals-Themen, monatliche Sprint-Ziele, klares Backlog. Sie wissen jederzeit, wo wir stehen." },
        { title: "Modell- & Stack-Updates", body: "Neues Claude- oder GPT-Modell? Wir testen, evaluieren, migrieren, ohne dass Sie das organisieren müssen. Stack-Updates (Bun, React, Tailwind) laufen unauffällig mit." },
        { title: "KI-Beratung inklusive", body: "Strategische Beratung ist Teil des Retainers, kein Extra. Wenn Sie überlegen, KI an einer neuen Stelle einzusetzen, denken wir mit, bevor irgendjemand baut." },
        { title: "Quartals-Review", body: "Alle drei Monate ein strukturiertes Review: Was wurde geliefert, was hat gewirkt, was ändern wir am Vorgehen. Schriftlich, mit Metriken." },
      ],
      process: [
        { label: "Monat 1", title: "Onboarding (wenn neu)", body: "Code-Audit, Doku-Lücken schließen, Monitoring scharf, Backup-Strategie. Wir wollen Ihre Codebase kennen, bevor wir daran weiterbauen." },
        { label: "Jeder Monat", title: "2-Wochen-Sprints", body: "Planning am Sprint-Start, Demo am Sprint-Ende. Sie sehen alle zwei Wochen ein Inkrement live auf Staging und entscheiden, was als Nächstes priorisiert wird." },
        { label: "Laufend", title: "Asynchron im Channel", body: "Fragen, Ideen, kleinere Anpassungen laufen über den gemeinsamen Channel. Größere Themen wandern ins Backlog für den nächsten Sprint." },
        { label: "Quartalsweise", title: "Review & Re-Scoping", body: "Alle drei Monate prüfen wir, ob das Sprint-Budget noch passt: hoch, runter, oder Pause. Kein automatisches Verlängern, kein Hidden-Auto-Renew." },
      ],
      faq: [
        { q: "Was kostet das?", a: "Monatlicher Retainer mit festem Stundenrahmen, planbar auf 6 bis 12 Monate. Wir staffeln nach gewünschter Kapazität. Konkreten Betrag nennen wir nach einem kurzen Scope-Gespräch, damit er zu Ihrem realen Bedarf passt. Festpreis, 3 Monate Mindestlaufzeit, danach monatlich kündbar." },
        { q: "Was, wenn wir in einem Monat nichts brauchen?", a: "Stunden rollen einen Monat weiter. Brauchen Sie länger nichts, pausieren wir den Retainer kostenlos und jederzeit wieder aktivierbar." },
        { q: "Müssen wir bei euch entwickelt haben?", a: "Nein. Wir übernehmen auch fremde Codebases, typisch nach einem 2 bis 4-wöchigen Onboarding, das wir zum reduzierten Festpreis anbieten." },
        { q: "Was unterscheidet das von einer normalen Agentur?", a: "Sie reden direkt mit den Devs, die auch coden. Kein Project Manager, der zwischen Ihnen und dem Team übersetzt. Kein Ticket-System mit SLA-Theater. Kleines Team, hohe Kontinuität." },
      ],
      pricing: {
        headline: "Monatlicher Retainer, Festpreis nach Scope",
        lines: [
          "Drei Stufen: Channel-Support & Roadmap-Pflege / monatliche Sprints / dedizierte Build-Partner-Kapazität.",
          "Fester Stundenrahmen pro Monat, unverbrauchte Stunden rollen einen Monat weiter.",
          "Konkreten Betrag besprechen wir nach kurzem Scope-Gespräch, kein Standard-Paket-Zwang.",
        ],
        note: "3 Monate Mindestlaufzeit, danach monatlich kündbar. Keine Auto-Renewal-Fallen.",
      },
      related: [
        { label: "AI Overlay", href: "/services/ai-overlay" },
        { label: "Website Rework, AI First", href: "/services/website-rework" },
        { label: "Kontakt aufnehmen", href: "/contact" },
      ],
    },
  },
  blog: {
    title: "Blog",
    subtitle: "Gedanken zu KI-Engineering, Design-Patterns und Erkenntnisse aus dem Entwickeln und Ausliefern KI-gestützter Produkte.",
    footerNoteBefore: "Weitere Artikel folgen bald. Möchten Sie auf dem Laufenden bleiben? Schreiben Sie uns an",
    readingSuffix: "Min. Lesezeit",
    posts: [
      {
        title: "Warum wir Bun statt Node für Produktions-KI-Apps gewählt haben",
        date: "2025-03-15",
        reading: 6,
        summary: "Buns integrierter Bundler, SQLite-Treiber und schnellere Startzeiten machten es zur richtigen Wahl für unsere KI-lastigen Server-Workloads. Was wir nach 6 Monaten in der Produktion gelernt haben.",
        tags: ["Bun", "Performance", "Architecture"],
      },
      {
        title: "RAG-Pipelines bauen, die wirklich funktionieren",
        date: "2025-02-28",
        reading: 8,
        summary: "Die meisten RAG-Tutorials enden bei „Dokumente einbetten und abfragen.“ Echter Produktions-RAG braucht Chunking-Strategien, hybride Suche, Re-Ranking und sorgfältige Evaluation. Ein praxisnaher Leitfaden aus dem Einsatz mit echten Nutzern.",
        tags: ["RAG", "AI", "LangChain"],
      },
      {
        title: "MCP: Das Protokoll, das verändert, wie KI Werkzeuge nutzt",
        date: "2025-02-10",
        reading: 5,
        summary: "Das Model Context Protocol ermöglicht KI-Modellen die Interaktion mit externen Werkzeugen über eine standardisierte Schnittstelle. Hier ist, warum jede KI-gestützte App MCP in Betracht ziehen sollte.",
        tags: ["MCP", "Tools", "Architecture"],
      },
      {
        title: "KI-Interfaces gestalten, die sich nicht wie Chatbots anfühlen",
        date: "2025-01-22",
        reading: 7,
        summary: "Chat ist der faule Standard für KI-UX. Echtes KI-natives Design bedeutet intelligente Standardwerte, kontextuelle Vorschläge und generativen Inhalt, der ins Produkt eingewoben ist. Kein Sidebar-Chatbot.",
        tags: ["Design", "UX", "AI"],
      },
    ],
  },
  careers: {
    title: "Karriere",
    subtitle: "Wir sind ein kleines Team, das KI-gestützte Software entwickelt. Wenn Sie begeistert davon sind, echte Produkte mit modernen Werkzeugen zu liefern, freuen wir uns von Ihnen zu hören.",
    howHeading: "Wie wir arbeiten",
    howBody: "Wir sind ein Remote-first-Studio mit Sitz in Stuttgart. Wir entwickeln Produkte, liefern Beratungsprojekte und tragen zu Open Source bei, oft alles in derselben Woche. Wir schätzen Menschen, die neugierig sind, schnell handeln und auf Qualität achten.",
    valuesHeading: "Werte",
    values: [
      { label: "Remote-first", desc: "Arbeiten von überall. Wir sind in Deutschland ansässig, aber unsere Arbeit ist nicht an einen Ort gebunden." },
      { label: "Schnell liefern", desc: "Wir messen Fortschritt in Tagen, nicht in Sprints. Wenn es funktioniert, liefern. Wenn nicht, lernen und weitermachen." },
      { label: "Offen entwickeln", desc: "Unsere Projekte sind Open Source. Wir teilen, was wir lernen, weil es alle besser macht." },
      { label: "Qualität zählt", desc: "Guter Code, gutes Design, gute Kommunikation. Wir kümmern uns um die Details, die Nutzer bemerken." },
    ],
    rolesHeading: "Stellen",
    requirementsLabel: "Was wir suchen",
    roles: [
      {
        title: "Full-Stack KI-Entwickler",
        type: "Freelance / Auftrag",
        description: "KI-gestützte Produkte von Anfang bis Ende entwickeln. Sie arbeiten über den gesamten Stack: React-Frontends, Bun/Node-Backends, LLM-Integrationen, Vektordatenbanken und Deployment-Infrastruktur.",
        requirements: [
          "Fundierte Erfahrung mit TypeScript und React",
          "Vertrautheit mit LLMs, RAG und KI-Tooling",
          "Eigenständiges Deployen in die Produktion",
          "Erfahrung mit Bun, Next.js oder ähnlichen modernen Runtimes",
        ],
      },
      {
        title: "KI/UX-Designer",
        type: "Freelance / Auftrag",
        description: "Interfaces für KI-native Produkte gestalten. Keine Chatbots, echte Produkterlebnisse, bei denen KI in jede Interaktion eingewoben ist. Sie entwickeln vom Konzept bis zu hochauflösenden Prototypen.",
        requirements: [
          "Portfolio mit KI- oder komplexem Produktdesign",
          "Sicher im Umgang mit Figma und Design-Systemen",
          "Fähigkeit zum Prototypen in Code (React/Tailwind) von Vorteil",
          "Verständnis der Möglichkeiten und Grenzen von LLMs",
        ],
      },
    ],
    ctaHeading: "Ihre Stelle nicht dabei?",
    ctaBodyBefore: "Wir sind immer daran interessiert, talentierte Menschen kennenzulernen. Schreiben Sie uns an",
    ctaBodyAfter: "mit ein paar Zeilen über sich und einem Link zu Ihren Arbeiten.",
  },
  work: {
    title: "Projekte",
    subtitle: "Die Produkte, die wir entworfen, entwickelt und veröffentlicht haben.",
    cases: [
      {
        title: "CATE",
        description: "Infinite-Canvas-IDE für parallele Coding-Agenten. Agent-fähige Terminals, Git-Worktrees, Editor- und Browser-Panels auf einem zoombaren Canvas. Open Source unter MIT-Lizenz.",
      },
      {
        title: "Open CLI Deployment",
        description: "Selbst gehostete, CLI-first Plattform zum Deployen von Containern auf eigene Server, mit TLS, Rollbacks und Scaling. Die Alternative zu Heroku, Railway und Render.",
      },
      {
        title: "Sight",
        description: "SEO- und KI-Sichtbarkeits-Audits. Eine Website scannen und einen bewerteten Bericht erhalten, der klassisches SEO abdeckt und zeigt, wie ChatGPT, Gemini, Claude und Perplexity Sie sehen.",
      },
      {
        title: "Skyline Spotter",
        description: "iOS-App zum Entdecken von Gebäuden in Ihrer Umgebung. Städte durchstöbern, Sichtungen sammeln und fehlende Gebäude und Fakten beisteuern.",
      },
      {
        title: "Foody",
        description: "iOS-App für Vorrat, Einkaufsliste und passende Rezepte in einem gemeinsamen Haushaltsstand.",
      },
    ],
  },
  stack: {
    title: "Tech Stack",
    subtitle: "Die Werkzeuge, Frameworks und Infrastruktur, die wir einsetzen, um KI-gestützte Produkte zu entwickeln und auszuliefern.",
    categories: [
      {
        name: "Frontend",
        tools: [
          { name: "React", desc: "UI-Framework für alle unsere Produkte" },
          { name: "Next.js", desc: "Full-Stack React für Produktionsanwendungen" },
          { name: "Tailwind CSS", desc: "Utility-first-Styling in jedem Projekt" },
          { name: "TypeScript", desc: "Strenge Typisierung überall, ohne Ausnahmen" },
          { name: "Monaco Editor", desc: "VS Code Editor-Komponente für CATE" },
        ],
      },
      {
        name: "Backend & Runtime",
        tools: [
          { name: "Bun", desc: "Schnelle JS-Runtime: Server, Bundler, Test-Runner" },
          { name: "Node.js", desc: "Produktions-Runtime für etablierte Dienste" },
          { name: "FastAPI", desc: "Python-Backend für ML-lastige Workloads" },
          { name: "Go", desc: "Hochleistungsdienste und CLI-Tools" },
        ],
      },
      {
        name: "KI & LLMs",
        tools: [
          { name: "Claude / Anthropic SDK", desc: "Primäres LLM für Generierung und Reasoning" },
          { name: "OpenRouter", desc: "Multi-Modell-Routing und Fallback" },
          { name: "LangChain", desc: "RAG-Pipelines und Agenten-Orchestrierung" },
          { name: "MCP", desc: "Model Context Protocol für Tool-Calling-Systeme" },
          { name: "Vercel AI SDK", desc: "Streaming-UI-Antworten" },
        ],
      },
      {
        name: "Datenbanken",
        tools: [
          { name: "MongoDB", desc: "Dokumentenspeicher für flexible Schemata" },
          { name: "Qdrant", desc: "Vektordatenbank für semantische Suche" },
          { name: "SQLite", desc: "Eingebettete Datenbank via bun:sqlite" },
          { name: "Redis", desc: "Caching, Rate-Limiting, Sessions" },
        ],
      },
      {
        name: "Infrastruktur",
        tools: [
          { name: "Docker", desc: "Containerisierte Deployments überall" },
          { name: "Terraform", desc: "Infrastructure as Code für Cloud-Ressourcen" },
          { name: "Hetzner", desc: "Europäisches Cloud-Hosting, schnell und erschwinglich" },
          { name: "Vercel", desc: "Frontend-Deployments und Edge Functions" },
          { name: "GitHub Actions", desc: "CI/CD für automatisierte Tests und Deployments" },
        ],
      },
      {
        name: "Design- & Entwicklungswerkzeuge",
        tools: [
          { name: "Figma", desc: "Design und Prototyping" },
          { name: "Electron", desc: "Desktop-Apps (CATE)" },
          { name: "xterm.js", desc: "Terminal-Emulation mit WebGL-Rendering" },
          { name: "Zustand", desc: "Leichtgewichtiges State-Management" },
        ],
      },
    ],
  },
  opensource: {
    title: "Open Source",
    subtitle: "Wir entwickeln offen. Unsere Werkzeuge, Bibliotheken und Experimente stehen jedem zur Verfügung. Zum Nutzen, Forken und Beitragen.",
    philosophyHeading: "Philosophie",
    philosophyBody: "Wir glauben, dass die besten Entwicklerwerkzeuge transparent und gemeinschaftsgetrieben sein sollten. Wenn wir etwas Nützliches bauen, teilen wir es. Wenn wir etwas Schwieriges lernen, dokumentieren wir es. Open Source ist keine Marketingstrategie. So glauben wir, sollte Software gebaut werden.",
    contributeHeading: "Mitwirken",
    contributeBody: "Wir begrüßen Beiträge jeder Art: Bug-Reports, Feature-Requests, Dokumentationsverbesserungen und Code. Die Contribution-Guidelines finden Sie im README jedes Repositories.",
    viewAllRepos: "Alle Repositories ansehen",
    projectsHeading: "Projekte",
    repos: [
      { name: "CATE", slug: "cate", description: "Infinite-Canvas-IDE, räumliche Entwicklungsumgebung mit Monaco-Editor, xterm.js-Terminal und Browser-Panels auf einer zoombaren Canvas." },
      { name: "Open CLI Deployment", slug: "one-click-deploy", description: "Selbst gehostete, CLI-first Plattform zum Deployen von Containern auf eigene Server, mit TLS, Rollbacks und Scaling." },
      { name: "0-AI", slug: null, description: "Diese Website, eine Bun + React Fullstack-App mit einer interaktiven KI-gestützten Canvas, entwickelt mit Tailwind CSS v4." },
    ],
  },
  notFound: {
    error: "Error 404",
    titles: [
      "Diese Seite ist im\nLatent Space verschollen.",
      "Das Modell hat diese\nURL halluziniert.",
      "Token nicht im\nKontextfenster gefunden.",
      "Auf null Gewichte\ntrainiert.",
      "Zu tief embedded,\nnicht mehr auffindbar.",
      "Prompt injection\nfehlgeschlagen.",
      "Segfault im\nneuronalen Netz.",
    ],
    stayNote: "Oder bleiben Sie und sammeln Sie ein paar Punkte.",
    startHint: "DRÜCKE LEERTASTE ODER TIPPE UM ZU STARTEN",
    gameOver: "GAME OVER",
    restart: "LEERTASTE / KLICK ZUM NEUSTARTEN",
    runnerLabel: "Runner",
    controls: "LEERTASTE · ↑ · KLICK · TAP",
  },
  impressum: {
    title: "Impressum",
    sec1Heading: "Angaben gemäß § 5 DDG",
    sec1Body: "0-AI UG (haftungsbeschränkt)\nNeckartalstraße 127\n70376 Stuttgart\nDeutschland",
    sec2Heading: "Vertreten durch",
    sec2Body: "Geschäftsführer:\nPaul Willi Patrick Horn\nAnton Leo Rudolf Horn",
    sec3Heading: "Kontakt",
    sec3Body: "E-Mail: contact@cero-ai.com",
    sec4Heading: "Registereintrag",
    sec4Body: "Eintragung im Handelsregister\nRegistergericht: Amtsgericht Stuttgart\nRegisternummer: In Eintragung",
    sec5Heading: "Umsatzsteuer-ID",
    sec5Body: "Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:\nBeantragt",
    sec6Heading: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
    sec6Body: "Paul Willi Patrick Horn\nNeckartalstraße 127\n70376 Stuttgart\n\nAnton Leo Rudolf Horn\nNeckartalstraße 127\n70376 Stuttgart",
    sec7Heading: "Streitschlichtung",
    sec7Body:
      "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
  },
  datenschutz: {
    title: "Datenschutzerklärung",
    toc: "Inhalt",
    lastUpdated: "Zuletzt aktualisiert: 24. September 2026",
    sections: [
      {
        number: "1",
        title: "Verantwortlicher",
        content: "0-AI UG (haftungsbeschränkt)\nNeckartalstraße 127\n70376 Stuttgart\nDeutschland\nE-Mail: datenschutz@cero-ai.com",
      },
      {
        number: "2",
        title: "Server-Logfiles",
        content: "Beim Besuch unserer Website übermittelt Ihr Browser automatisch technische Informationen, die in Server-Logfiles gespeichert werden können.",
        list: [
          "Browsertyp und -version",
          "Verwendetes Betriebssystem",
          "Referrer URL",
          "IP-Adresse des zugreifenden Rechners",
          "Uhrzeit der Serveranfrage",
        ],
        footer: "Wir verwenden diese Informationen zur Auslieferung und Absicherung der Website, zur Fehleranalyse und zur Missbrauchsprävention.",
      },
      {
        number: "3",
        title: "Webanalyse",
        content: "Wir betreiben unter analytics.cero-ai.com einen cookielosen Analysedienst. Er erfasst besuchte Domain und Pfad, Referrer, Bildschirmabmessungen, Zeitpunkt sowie technische Anfragedaten. IP-Adresse und User-Agent werden vorübergehend verwendet, um mittels Einweg-Hash eine pseudonyme Besucherkennung zu bilden. Die rohe IP-Adresse wird nicht in den Analysedatensatz geschrieben, kann jedoch in üblichen Server-Logfiles enthalten sein. Das Analyseskript verwendet weder Cookies noch Browser-Speicher. Separat laden wir Google Analytics zur Messung von Seitenaufrufen nur, wenn Sie „Analyse erlauben“ auswählen. Google Ireland Limited kann Seiten-, Browser- und Gerätedaten erhalten und Cookies oder ähnliche Kennungen verwenden; eine Verarbeitung durch Google LLC in den USA kann stattfinden. Vor Ihrer Einwilligung laden wir diesen Google-Tag nicht. Ihre Wahl wird im Browser gespeichert und kann über „Datenschutzeinstellungen“ geändert werden. Grundlage der optionalen Messung ist Ihre Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und § 25 TDDDG.",
      },
      {
        number: "4",
        title: "Externe Schriftarten",
        content: "Für die Darstellung unserer Typografie ruft die Website Schriftstile und -dateien von Google Fonts (Google) und Fontshare (Indian Type Foundry) ab. Beim Laden erhalten die Anbieter technische Anfragedaten wie Ihre IP-Adresse, Browserinformationen, die angeforderte Ressource und den Zeitpunkt des Abrufs.",
      },
      {
        number: "5",
        title: "Kontaktaufnahme",
        content: "Wenn Sie uns per E-Mail kontaktieren, speichern wir die von Ihnen übermittelten Angaben zur Beantwortung der Anfrage und möglicher Rückfragen. Wir geben sie nur weiter, soweit dies zur Bearbeitung erforderlich oder gesetzlich vorgeschrieben ist.",
      },
      {
        number: "6",
        title: "Rechtsgrundlagen",
        content: "Server-Log- und cookielose Analysedaten verarbeiten wir gemäß Art. 6 Abs. 1 lit. f DSGVO auf Grundlage unserer berechtigten Interessen am sicheren Betrieb sowie an der Auswertung und Verbesserung der Website. E-Mail-Anfragen verarbeiten wir gemäß Art. 6 Abs. 1 lit. b DSGVO oder bei allgemeinen Anfragen gemäß Art. 6 Abs. 1 lit. f DSGVO. Externe Schriftarten laden wir gemäß Art. 6 Abs. 1 lit. f DSGVO für eine einheitliche Darstellung der Website.",
      },
      {
        number: "7",
        title: "Dienstleister und internationale Übermittlungen",
        content: "Für den Betrieb der Website nutzen wir externe Hosting-Anbieter und die oben genannten Dienste. Google und Fontshare können Daten außerhalb der EU bzw. des EWR verarbeiten. Soweit erforderlich, stützen wir internationale Übermittlungen auf einen anwendbaren Angemessenheitsbeschluss, die Standardvertragsklauseln der Europäischen Kommission oder eine andere gesetzlich anerkannte Garantie. Datenschutzinformationen der Anbieter finden Sie auf deren jeweiligen Websites.",
      },
      {
        number: "8",
        title: "Speicherdauer",
        content: "Server-Logs und Daten zur Ratenbegrenzung speichern wir nur so lange, wie dies für Sicherheit und Fehleranalyse erforderlich ist. Analysedaten werden nur so lange gespeichert, wie sie für Betrieb, Auswertung und Verbesserung des jeweiligen Dienstes benötigt werden, und anschließend gelöscht oder anonymisiert. E-Mail-Korrespondenz speichern wir, solange dies zur Bearbeitung und zur Erfüllung gesetzlicher Aufbewahrungspflichten erforderlich ist. Unter datenschutz@cero-ai.com können Sie die Löschung der Ihnen zugeordneten Daten verlangen.",
      },
      {
        number: "9",
        title: "Ihre Rechte",
        content: "Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:",
        rights: [
          ["Auskunft", "Art. 15 DSGVO"],
          ["Berichtigung", "Art. 16 DSGVO"],
          ["Löschung", "Art. 17 DSGVO"],
          ["Einschränkung der Verarbeitung", "Art. 18 DSGVO"],
          ["Datenübertragbarkeit", "Art. 20 DSGVO"],
          ["Widerspruch", "Art. 21 DSGVO"],
        ],
        rightPrefix: "Recht auf",
      },
      {
        number: "10",
        title: "Beschwerderecht",
        content: "Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren.",
      },
      {
        number: "11",
        title: "SSL-/TLS-Verschlüsselung",
        content: "Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von http:// auf https:// wechselt.",
      },
    ],
  },
  meta: {
    "/": {
      title: "0-AI | We Rethink Web with AI",
      description: "Wir bauen KI- und Web-Produkte schnell. Beratung, Design und Entwicklung für Unternehmen, die KI-gestützte Software ausliefern wollen.",
    },
    "/skyline/privacy": {
      title: "Skyline Privacy Policy | 0-AI",
      description: "Privacy policy for the Skyline iOS app: what data the app collects, how it is used, and your rights.",
    },
    "/skyline/terms": {
      title: "Skyline Terms of Service | 0-AI",
      description: "Terms governing use of the Skyline iOS app and community.",
    },
    "/skyline/support": {
      title: "Skyline Support | 0-AI",
      description: "Help with Skyline accounts, building collections, photo matching, safety, and privacy.",
    },
    "/products": {
      title: "Produkte. 0-AI",
      description: "CATE, Open CLI Deployment, Sight, Skyline Spotter und Foody. Produkte von 0-AI.",
    },
    "/products/ai-overlay": {
      title: "AI Overlay | 0-AI",
      description: "Eine kontextbezogene KI-Ebene für Ihre bestehende Website, trainiert auf Ihren Inhalten und ohne Relaunch einsatzbereit.",
    },
    "/services/ai-overlay": {
      title: "AI Overlay Services | 0-AI",
      description: "Eine kontextbezogene KI-Ebene für Ihre bestehende Website, trainiert auf Ihren Inhalten und in ein bis zwei Wochen integriert.",
    },
    "/services/langzeit-betreuung": {
      title: "Langzeit-Betreuung | 0-AI",
      description: "Laufende KI-Strategie, Wartung und Produktentwicklung mit dem Team, das Ihre Lösung gebaut hat.",
    },
    "/products/cate": {
      title: "CATE. Canvas Terminal Editor | 0-AI",
      description: "Eine unendliche, zoombare Canvas mit räumlichen Terminals, Editoren und Browsern. Open Source IDE von 0-AI.",
    },
    "/products/one-click-deploy": {
      title: "Open CLI Deployment | 0-AI",
      description: "Open-Source, CLI-first Plattform zum Deployen von Containern auf eigene Server mit TLS, Rollbacks und Scaling. Die Alternative zu Heroku, Railway und Render.",
    },
    "/consulting": {
      title: "KI-Beratung | 0-AI",
      description: "Praxisnahe KI-Strategie und Umsetzung für Teams, die intelligente Produkte entwickeln.",
    },
    "/design": {
      title: "KI-Produktdesign | 0-AI",
      description: "Designsysteme und Interfaces für klare, nützliche KI-gestützte Produkte.",
    },
    "/engineering": {
      title: "KI-Engineering | 0-AI",
      description: "Full-Stack-KI-Engineering vom Prototyp bis zu zuverlässigen Produktivsystemen.",
    },
    "/about": {
      title: "Über uns. 0-AI",
      description: "Wir sind 0-AI, ein kleines Studio, das Unternehmen hilft, KI schnell zu adoptieren, durch Beratung, Design und Engineering.",
    },
    "/contact": {
      title: "Kontakt. 0-AI",
      description: "Kontaktieren Sie 0-AI. Lassen Sie uns über Ihr Projekt sprechen.",
    },
    "/work": {
      title: "Projekte. 0-AI",
      description: "Case Studies und Projekte, geliefert von 0-AI für Kunden aus verschiedenen Branchen.",
    },
    "/stack": {
      title: "Tech Stack. 0-AI",
      description: "Die Technologien, die wir nutzen: Bun, React, TypeScript, Claude und mehr.",
    },
    "/blog": {
      title: "Blog. 0-AI",
      description: "Insights zu KI-Entwicklung, Produktbau und Engineering vom 0-AI-Team.",
    },
    "/careers": {
      title: "Karriere. 0-AI",
      description: "Werden Sie Teil von 0-AI. Offene Positionen in Engineering und Design.",
    },
    "/open-source": {
      title: "Open Source. 0-AI",
      description: "Unsere Open-Source-Projekte und Beiträge zur Entwickler-Community.",
    },
    "/pricing": {
      title: "Preise. 0-AI",
      description: "Drei Pakete für jede Größe. Wartungsvertrag und KI-Layer optional kombinierbar.",
    },
    "/impressum": {
      title: "Impressum. 0-AI",
      description: "Impressum und Unternehmensinformationen für 0-AI / 0-AI UG.",
    },
    "/datenschutz": {
      title: "Datenschutz. 0-AI",
      description: "Datenschutzerklärung für 0-AI / 0-AI UG.",
    },
    notFound: {
      title: "404. Seite nicht gefunden | 0-AI",
      description: "Diese Seite existiert nicht. Aber ein kleiner Runner wartet auf Sie.",
    },
  },
  langSwitch: {
    aria: "Sprache wechseln",
    de: "DE",
    en: "EN",
  },
  ai: {
    newChat: "Neuer Chat",
    open: "Öffnen",
    delete: "Löschen",
    askPlaceholder: "Stellen Sie uns Ihre Frage.",
    rateLimited: "Tageslimit erreicht, bitte kommen Sie morgen wieder.",
    phaseLoading: "Wird verarbeitet.",
    phaseStreaming: "Wird erstellt.",
    failed: "Antwort konnte nicht generiert werden.",
    openAi: "Ask AI",
    sectionsOne: "Abschnitt",
    sectionsMany: "Abschnitte",
    justNow: "Gerade eben",
    minutesAgo: "vor {{n}} Min.",
    hoursAgo: "vor {{n}} Std.",
    daysAgoOne: "vor 1 Tag",
    daysAgoMany: "vor {{n}} Tagen",
    chatPlaceholderTitle: "Gespräch",
    openContactPrompt: "Bitte zeige mir ein Kontaktformular, damit ich euch direkt eine Nachricht schicken kann.",
    openPricingPrompt: "Bitte zeige mir eine übersichtliche Preisübersicht für CERO AI Leistungen und hilf mir, das passende Paket zu wählen.",
    pills: {
      "service-ai-overlay": "AI Overlay",
      "service-website-rework": "Website Rework",
      "service-langzeit-betreuung": "Langzeit-Betreuung",
      "pricing": "Preise",
      "our-process": "Unser Prozess",
      "about-us": "Über uns",
      "open-source": "Open Source",
    },
  },
  start: {
    cards: {
      overlay: {
        n: "01",
        label: "AI Overlay",
        tagline: "KI-Layer auf bestehender Site",
        desc: "Kontextbezogen, trainiert auf Ihren Inhalten, wie der hier. Ab €29/Monat.",
      },
      rework: {
        n: "02",
        label: "Website Rework: AI First",
        tagline: "Bestehend → KI-nativ",
        desc: "Re-Design mit KI als zentraler Interaktion. Festpreis, fixe Phasen, planbarer Launch.",
      },
      longterm: {
        n: "03",
        label: "Langzeit-Betreuung",
        tagline: "Direkt mit den Devs",
        desc: "Beratung, Wartung und Weiterentwicklung mit denselben Köpfen, die gebaut haben.",
      },
    },
    secondary: {
      about: { label: "Über uns", desc: "Unser Studio & Team" },
      cases: { label: "Cases & Referenzen", desc: "Ausgewählte Projekte" },
      opensource: { label: "Open Source", desc: "Unsere Projekte auf GitHub" },
    },
  },
  // Copy-Overrides, nur aktiv wenn das AI_OVERLAY_ONLY-Gate gesetzt ist. Die
  // Seite bleibt eine volle Agentur-Seite, bewirbt aber kein Website-Building/Rework mehr.
  overlayGate: {
    hero: {
      title: "KI-Layer und Beratung für Ihre Website.",
      subtitle:
        "Wir bauen einen kontextbezogenen KI-Layer auf Ihrer bestehenden Seite und begleiten Sie langfristig. Direkte Zusammenarbeit mit denen, die auch coden.",
    },
    products: {
      lead: "Zwei Kern-Angebote, gebaut für direkte, langfristige Zusammenarbeit. Sie reden mit denen, die auch coden. Keine Account-Manager-Schicht dazwischen.",
    },
    pricing: {
      subtitle:
        "Der kontextbezogene KI-Layer für Ihre bestehende Website. Basic- und Pro-Tarif oder Abrechnung pro Antwort. Preise inkl. MwSt.",
      teaserTitle: "KI-Layer. Klarer Preis.",
      teaserLead: "Zwei Tarife oder Abrechnung pro Antwort. Alle Details und Antwort-Pakete auf der Preisseite.",
      perMonth: "/Monat bei 12 Monaten Laufzeit",
    },
  },
} as const;
